import Routes from './Routes';
import ROUTES from './RoutesConstants';

export { ROUTES };

export default Routes;
